import { Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled, { withTheme } from "styled-components"

import WithCollection from "areas/collection/hoc/with-collection"
import RangeSlider from "components/form/range-slider"
import { to_currency } from "helpers/number"

const Container = styled.div`
  ${({ theme }) => theme.mediaQueries.tablet`
    max-width: 380px;
  `}
`
const PriceRange = ({
  filteredPriceRange,
  priceRange,
  updatePriceRange,
  theme,
}) => {
  if (!priceRange || priceRange.min === priceRange.max) return null

  // if there's only one item, freeze the slider
  if (priceRange.min == priceRange.max) {
    priceRange.max += 0.1
    priceRange.min -= 0.1
    filteredPriceRange.min -= 0.1
    filteredPriceRange.max += 0.1

    return (
      <Container>
        <Flex justifyContent="space-between" margin="0 0 10px">
          <Typography color="primary">{to_currency(priceRange.min)}</Typography>
          <Typography color="primary">{to_currency(priceRange.min)}</Typography>
        </Flex>
        <RangeSlider
          filteredValues={[priceRange.min, priceRange.max]}
          max={priceRange.max}
          min={priceRange.min}
          onChange={updatePriceRange}
        />
      </Container>
    )
  }

  return (
    <Container>
      <Flex justifyContent="space-between" margin="0 0 10px">
        <Typography color={theme.collectionFilter.themeColor}>
          {to_currency(filteredPriceRange.min, { precision: 2 })}
        </Typography>
        <Typography color={theme.collectionFilter.themeColor}>
          {to_currency(filteredPriceRange.max, { precision: 2 })}
        </Typography>
      </Flex>
      <RangeSlider
        filteredValues={[filteredPriceRange.min, filteredPriceRange.max]}
        max={priceRange.max}
        min={priceRange.min}
        onChange={updatePriceRange}
      />
    </Container>
  )
}

PriceRange.propTypes = {
  filteredPriceRange: PropTypes.object,
  priceRange: PropTypes.object,
  theme: PropTypes.object,
  updatePriceRange: PropTypes.func,
}

export default withTheme(WithCollection(PriceRange))
